import SystemContainer from "./SystemContainer";

export default SystemContainer;
